import { createContext } from "react";
import { observer } from "mobx-react-lite";
import TvGuideStore from "./tv-guide.store";
import DataManager from "./data.manager";

const defaultStore = new TvGuideStore();
export const AppContext = createContext(new DataManager(defaultStore));

// type AppContextProviderProps = {
//     children: any;
//     dataManager: DataManager;
// }

// export const AppContextProvider = observer<any>((props: AppContextProviderProps) => (
//     <AppContext.Provider value={props.dataManager}>{props.children}</AppContext.Provider>
// ));
export const AppContextProvider = observer<any>(({ children, dataManager }: { children: any, dataManager: DataManager, manager: DataManager }) => (
    <AppContext.Provider value={dataManager}>{children}</AppContext.Provider>
));